import { GpPodiumListQuery } from './types';
import { IMotorsportsGpStandings, MotorsportsGpStandings } from '@sky-it-livedata/livedata-sports-design-system';
import { WidgetContext } from "../../types/WidgetContext";
import transformQuery from "./transformers/query-transformer";
import { log } from "../../utils/log";
import { useIntcmp } from '../../hooks/useIntcmp';

export const disableClientRender = true;

export const setCustomAttributes = ({
  variables,
}: WidgetContext<GpPodiumListQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<GpPodiumListQuery>): IMotorsportsGpStandings => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<IMotorsportsGpStandings>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();
  
  return (
    <div onClick={intCmpEventHandler}>
      <MotorsportsGpStandings {...props} />   
    </div>
  )
};

export default ResultsContainer;